import types from './mutations-types';
import moment from 'moment';

const defaultSelect = (state, { optionNm, valueNm }) => {
	state[valueNm] = state[optionNm][0]['value'];
};

const changeValue = (state, data) => {
	if (data.name == 'searchMonth') data.value = moment(data.value).format('YYYY-MM');
	state[`${data.name}`] = data.value;
};

export default {
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	},
	defaultSelect,
	changeValue
};
